// test716
(716 && 0);
